import { Link } from 'react-router-dom';
import { ROUTES } from '../../../config/constants';
import { formatTimeAgo } from '../../../lib/format';
import { useHealthPhoto } from '../../../hooks/useHealthPhoto';
import Card from '../../../components/ui/Card';
import { TYPE_META } from './HealthRecordTypeChips';

/**
 * Tarjeta de un record de salud. Link al edit.
 * Foto opcional integrada en Sprint 3 stage de fotos.
 */

const formatDate = (ts) => {
  const ms = ts?.toMillis?.() ?? null;
  if (!ms) return '—';
  const d = new Date(ms);
  return d.toLocaleDateString('es-AR', { day: 'numeric', month: 'long', year: 'numeric' });
};

const formatWeight = (kg) => {
  if (kg == null) return null;
  // si es entero (5.0), mostrar 5 kg; si tiene decimales, 5.4 kg
  const rounded = Number.isInteger(kg) ? `${kg}` : kg.toFixed(2).replace(/0$/, '').replace(/\.$/, '');
  return `${rounded} kg`;
};

const HealthRecordCard = ({ record, petId }) => {
  const meta = TYPE_META[record.type] ?? TYPE_META.note;
  const Icon = meta.icon;
  const { url: photoUrl } = useHealthPhoto(record);

  const editPath = ROUTES.HEALTH_RECORD_EDIT
    .replace(':petId', petId ?? record.petId)
    .replace(':recordId', record.id);

  const occurredMs = record.occurredAt?.toMillis?.() ?? null;
  const weight = formatWeight(record.weightKg);

  return (
    <Link
      to={editPath}
      className="block focus:outline-none focus:ring-2 focus:ring-brand-500 rounded-2xl"
    >
      <Card className="hover:shadow-md transition-shadow">
        <div className="flex items-start gap-3">
          <div className={['flex h-10 w-10 shrink-0 items-center justify-center rounded-xl', meta.className].join(' ')}>
            <Icon className="h-5 w-5" aria-hidden="true" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2">
              <h3 className="font-semibold leading-tight text-slate-900">
                {record.title}
              </h3>
              <span className="text-xs text-slate-400 shrink-0">
                {meta.label}
              </span>
            </div>
            <p className="mt-0.5 text-sm text-slate-600">
              {formatDate(record.occurredAt)}
              {occurredMs && (
                <span className="text-slate-400"> · {formatTimeAgo(occurredMs)}</span>
              )}
            </p>
            {(weight || record.productName) && (
              <p className="mt-1 text-sm text-slate-700">
                {weight && <span className="font-medium">{weight}</span>}
                {weight && record.productName && <span className="text-slate-400"> · </span>}
                {record.productName && <span>{record.productName}</span>}
              </p>
            )}
            {record.notes && (
              <p className="mt-1.5 text-sm text-slate-600 line-clamp-2">{record.notes}</p>
            )}
          </div>
          {photoUrl && (
            <img
              src={photoUrl}
              alt=""
              className="h-16 w-16 shrink-0 rounded-xl object-cover ring-1 ring-slate-200"
              loading="lazy"
              referrerPolicy="no-referrer"
            />
          )}
        </div>
      </Card>
    </Link>
  );
};

export default HealthRecordCard;
